module.exports = __webpack_public_path__ + "img/horizontal_3_4_7016.7dd9c02f.png";